// Dummy data for Botibonga Studio
import {
  ShoppingBag,
  Headphones,
  Hotel,
  Briefcase,
  Smile,
  Stethoscope,
  UtensilsCrossed,
  Home,
  Dumbbell,
  BookOpen,
  ShoppingCart,
  Calendar,
  Globe,
  Target,
} from "lucide-react";

export const dummyAgents = [
  {
    id: "agent-1",
    name: "Sales Assistant",
    businessType: "E-commerce",
    businessDescription:
      "Online store selling handmade jewelry and accessories. We specialize in custom pieces and personalized gifts.",
    language: "English",
    behavior:
      "You are a friendly and helpful sales assistant for a handmade jewelry store. Help customers find the perfect piece, answer questions about materials and sizing, and provide information about custom orders.",
    features: {
      autoReply: true,
      leadCapture: true,
      appointmentBooking: false,
      gmailIntegration: true,
      humanHandoff: true,
    },
    status: "live",
    whatsappConnected: true,
    whatsappNumber: "+1 (555) 123-4567",
    respondTo: "all",
    whitelist: [],
    createdAt: "2024-01-15T10:00:00Z",
    stats: {
      totalConversations: 247,
      activeConversations: 12,
      leadsCollected: 89,
      messagesHandled: 1543,
    },
  },
  {
    id: "agent-2",
    name: "Support Bot",
    businessType: "SaaS",
    businessDescription:
      "Project management software for remote teams. We help teams collaborate, track tasks, and meet deadlines.",
    language: "English",
    behavior:
      "You are a helpful support agent for a project management software. Assist users with technical questions, troubleshooting, and feature explanations. Be patient and thorough.",
    features: {
      autoReply: true,
      leadCapture: false,
      appointmentBooking: true,
      gmailIntegration: false,
      humanHandoff: true,
    },
    status: "paused",
    whatsappConnected: true,
    whatsappNumber: "+1 (555) 987-6543",
    respondTo: "whitelist",
    whitelist: ["+1555111222", "+1555333444"],
    createdAt: "2024-02-20T14:30:00Z",
    stats: {
      totalConversations: 156,
      activeConversations: 0,
      leadsCollected: 34,
      messagesHandled: 892,
    },
  },
  {
    id: "agent-3",
    name: "Restaurant Booking",
    businessType: "Restaurant",
    businessDescription:
      "Italian family restaurant in downtown. We serve authentic Italian cuisine with recipes passed down for generations.",
    language: "English",
    behavior:
      "You are a friendly host for an Italian restaurant. Help guests make reservations, answer questions about the menu, dietary accommodations, and special events. Be warm and welcoming.",
    features: {
      autoReply: true,
      leadCapture: true,
      appointmentBooking: true,
      gmailIntegration: false,
      humanHandoff: false,
    },
    status: "live",
    whatsappConnected: false,
    whatsappNumber: "",
    respondTo: "all",
    whitelist: [],
    createdAt: "2024-03-01T09:15:00Z",
    stats: {
      totalConversations: 0,
      activeConversations: 0,
      leadsCollected: 0,
      messagesHandled: 0,
    },
  },
];

export const dummyConversations = {
  "agent-1": [
    {
      id: "conv-1",
      contactName: "Sarah Johnson",
      contactNumber: "+1 (555) 234-5678",
      lastMessage: "Thank you! I love the necklace design.",
      lastMessageTime: "2024-03-15T14:32:00Z",
      unread: 2,
      messages: [
        {
          id: "m1",
          type: "user",
          text: "Hi! Do you have any rose gold necklaces?",
          time: "2024-03-15T14:20:00Z",
        },
        {
          id: "m2",
          type: "ai",
          text: "Hello Sarah! Yes, we have a beautiful collection of rose gold necklaces. Our most popular ones are the Delicate Chain and the Heart Pendant. Would you like me to show you some options?",
          time: "2024-03-15T14:20:30Z",
        },
        {
          id: "m3",
          type: "user",
          text: "Yes please! I'm looking for something for my mom's birthday",
          time: "2024-03-15T14:25:00Z",
        },
        {
          id: "m4",
          type: "ai",
          text: "How sweet! 💝 For a birthday gift, I'd recommend our Birthstone Heart Pendant - we can customize it with your mom's birthstone. We also have an elegant Infinity Rose Gold Necklace that's perfect for mothers. What's your budget range?",
          time: "2024-03-15T14:25:45Z",
        },
        {
          id: "m5",
          type: "user",
          text: "Around $150-200",
          time: "2024-03-15T14:30:00Z",
        },
        {
          id: "m6",
          type: "ai",
          text: "Perfect! Both options fall within that range. The Birthstone Pendant is $165 and the Infinity Necklace is $185. Both come in a beautiful gift box. Would you like me to send you photos?",
          time: "2024-03-15T14:30:30Z",
        },
        {
          id: "m7",
          type: "user",
          text: "Thank you! I love the necklace design.",
          time: "2024-03-15T14:32:00Z",
        },
      ],
    },
    {
      id: "conv-2",
      contactName: "Mike Chen",
      contactNumber: "+1 (555) 345-6789",
      lastMessage: "When will my order arrive?",
      lastMessageTime: "2024-03-15T11:45:00Z",
      unread: 0,
      messages: [
        {
          id: "m1",
          type: "user",
          text: "When will my order arrive?",
          time: "2024-03-15T11:45:00Z",
        },
        {
          id: "m2",
          type: "ai",
          text: "Hi Mike! I'd be happy to help you track your order. Could you please provide your order number?",
          time: "2024-03-15T11:45:30Z",
        },
      ],
    },
    {
      id: "conv-3",
      contactName: "Emma Williams",
      contactNumber: "+1 (555) 456-7890",
      lastMessage: "Can you do custom engravings?",
      lastMessageTime: "2024-03-14T16:20:00Z",
      unread: 1,
      messages: [
        {
          id: "m1",
          type: "user",
          text: "Can you do custom engravings?",
          time: "2024-03-14T16:20:00Z",
        },
      ],
    },
    {
      id: "conv-4",
      contactName: "David Brown",
      contactNumber: "+1 (555) 567-8901",
      lastMessage: "Perfect, I'll place the order now",
      lastMessageTime: "2024-03-14T10:15:00Z",
      unread: 0,
      messages: [
        {
          id: "m1",
          type: "user",
          text: "Do you ship internationally?",
          time: "2024-03-14T09:30:00Z",
        },
        {
          id: "m2",
          type: "ai",
          text: "Yes, we do! We ship to over 50 countries. Shipping times vary from 7-14 business days depending on location. Where would you like us to ship to?",
          time: "2024-03-14T09:30:45Z",
        },
        {
          id: "m3",
          type: "user",
          text: "To Canada",
          time: "2024-03-14T10:00:00Z",
        },
        {
          id: "m4",
          type: "ai",
          text: "Great news! We ship to Canada frequently. Standard shipping is $12.99 and takes about 7-10 business days. Express shipping is $24.99 and arrives in 3-5 business days. Would you like to proceed with an order?",
          time: "2024-03-14T10:01:00Z",
        },
        {
          id: "m5",
          type: "user",
          text: "Perfect, I'll place the order now",
          time: "2024-03-14T10:15:00Z",
        },
      ],
    },
  ],
  "agent-2": [
    {
      id: "conv-5",
      contactName: "Jennifer Lee",
      contactNumber: "+1 (555) 678-9012",
      lastMessage: "How do I add team members?",
      lastMessageTime: "2024-03-13T15:30:00Z",
      unread: 0,
      messages: [
        {
          id: "m1",
          type: "user",
          text: "How do I add team members?",
          time: "2024-03-13T15:30:00Z",
        },
        {
          id: "m2",
          type: "ai",
          text: "Hi Jennifer! To add team members, go to Settings > Team > Invite Members. Enter their email addresses and choose their role (Admin, Editor, or Viewer). They'll receive an invitation email to join your workspace. Would you like me to guide you through any specific step?",
          time: "2024-03-13T15:31:00Z",
        },
      ],
    },
  ],
  "agent-3": [],
};

export const dummyLeads = {
  "agent-1": [
    {
      id: "lead-1",
      name: "Sarah Johnson",
      phone: "+1 (555) 234-5678",
      email: "sarah.j@email.com",
      interest: "Rose gold jewelry",
      capturedAt: "2024-03-15T14:20:00Z",
      tags: ["Hot Lead", "Birthday Gift"],
    },
    {
      id: "lead-2",
      name: "Mike Chen",
      phone: "+1 (555) 345-6789",
      email: "mike.c@email.com",
      interest: "Order inquiry",
      capturedAt: "2024-03-15T11:45:00Z",
      tags: ["Existing Customer"],
    },
    {
      id: "lead-3",
      name: "Emma Williams",
      phone: "+1 (555) 456-7890",
      email: "",
      interest: "Custom engravings",
      capturedAt: "2024-03-14T16:20:00Z",
      tags: ["Custom Order"],
    },
    {
      id: "lead-4",
      name: "David Brown",
      phone: "+1 (555) 567-8901",
      email: "david.b@email.com",
      interest: "International shipping",
      capturedAt: "2024-03-14T10:00:00Z",
      tags: ["International"],
    },
    {
      id: "lead-5",
      name: "Lisa Anderson",
      phone: "+1 (555) 678-9012",
      email: "lisa.a@email.com",
      interest: "Wedding jewelry",
      capturedAt: "2024-03-12T09:00:00Z",
      tags: ["Hot Lead", "Wedding"],
    },
  ],
  "agent-2": [
    {
      id: "lead-6",
      name: "Jennifer Lee",
      phone: "+1 (555) 678-9012",
      email: "jennifer.l@email.com",
      interest: "Team plan inquiry",
      capturedAt: "2024-03-13T15:30:00Z",
      tags: ["Enterprise"],
    },
  ],
  "agent-3": [],
};

export const dummyKnowledgeBase = {
  "agent-1": [
    {
      id: "kb-1",
      name: "Product Catalog 2024.pdf",
      type: "application/pdf",
      size: 2457600,
      uploadedAt: "2024-01-15T10:30:00Z",
    },
    {
      id: "kb-2",
      name: "Pricing Guide.docx",
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      size: 159744,
      uploadedAt: "2024-01-15T10:35:00Z",
    },
    {
      id: "kb-3",
      name: "FAQ Document.pdf",
      type: "application/pdf",
      size: 911360,
      uploadedAt: "2024-02-01T14:00:00Z",
    },
    {
      id: "kb-4",
      name: "Shipping Policy.txt",
      type: "text/plain",
      size: 12288,
      uploadedAt: "2024-02-10T09:00:00Z",
    },
  ],
  "agent-2": [
    {
      id: "kb-5",
      name: "User Manual.pdf",
      type: "application/pdf",
      size: 5452595,
      uploadedAt: "2024-02-20T14:45:00Z",
    },
    {
      id: "kb-6",
      name: "API Documentation.pdf",
      type: "application/pdf",
      size: 3250585,
      uploadedAt: "2024-02-20T14:50:00Z",
    },
  ],
  "agent-3": [],
};

export const behaviorTemplates = [
  {
    id: "friendly-sales",
    name: "Friendly Sales",
    icon: ShoppingBag,
    prompt:
      "You are a friendly and helpful sales assistant. Engage warmly with customers, understand their needs, and guide them to the right products. Be enthusiastic but not pushy. Always aim to help, even if it means recommending something outside your catalog.",
  },
  {
    id: "professional-support",
    name: "Professional Support",
    icon: Headphones,
    prompt:
      "You are a professional customer support agent. Be patient, thorough, and solution-oriented. Acknowledge customer frustrations, provide clear step-by-step guidance, and always follow up to ensure issues are resolved.",
  },
  {
    id: "warm-hospitality",
    name: "Warm Hospitality",
    icon: Hotel,
    prompt:
      "You are a warm and welcoming host. Make every guest feel special and valued. Anticipate needs, offer personalized recommendations, and create memorable experiences. Be knowledgeable about your offerings and local area.",
  },
  {
    id: "expert-consultant",
    name: "Expert Consultant",
    icon: Briefcase,
    prompt:
      "You are an expert consultant in your field. Provide thoughtful, well-researched advice. Ask clarifying questions to understand the full picture before making recommendations. Be confident but humble, and always cite your reasoning.",
  },
  {
    id: "casual-helper",
    name: "Casual & Helpful",
    icon: Smile,
    prompt:
      "You are a casual and approachable assistant. Use friendly language, emojis occasionally, and make conversations feel natural. Be helpful without being formal. Think of yourself as a knowledgeable friend.",
  },
  {
    id: "healthcare-assistant",
    name: "Healthcare Assistant",
    icon: Stethoscope,
    prompt:
      "You are a caring healthcare assistant. Help patients with appointment scheduling, general health inquiries, and clinic information. Be empathetic and reassuring. Always remind users to consult a doctor for medical advice. Respect privacy and maintain a calm, professional tone.",
  },
  {
    id: "restaurant-host",
    name: "Restaurant Host",
    icon: UtensilsCrossed,
    prompt:
      "You are a friendly restaurant host. Help guests with reservations, menu questions, dietary accommodations, and special requests. Be warm and inviting. Share recommendations enthusiastically and make every guest feel like a VIP.",
  },
  {
    id: "real-estate-agent",
    name: "Real Estate Agent",
    icon: Home,
    prompt:
      "You are a knowledgeable real estate assistant. Help clients find properties that match their needs, answer questions about listings, neighborhoods, and the buying process. Be patient, informative, and guide them through each step with confidence.",
  },
  {
    id: "fitness-coach",
    name: "Fitness Coach",
    icon: Dumbbell,
    prompt:
      "You are an energetic fitness coach. Motivate clients, answer questions about workouts, memberships, and class schedules. Be encouraging and positive. Help people feel excited about their fitness journey without being intimidating.",
  },
  {
    id: "education-tutor",
    name: "Education Tutor",
    icon: BookOpen,
    prompt:
      "You are a patient and encouraging tutor. Help students with course information, enrollment questions, and general academic guidance. Explain things clearly and make learning feel accessible. Celebrate small wins and encourage curiosity.",
  },
  {
    id: "ecommerce-concierge",
    name: "E-commerce Concierge",
    icon: ShoppingCart,
    prompt:
      "You are a helpful e-commerce concierge. Assist customers with product discovery, order tracking, returns, and recommendations. Be quick to respond, solution-focused, and always aim to exceed expectations. Make online shopping feel personal.",
  },
  {
    id: "appointment-scheduler",
    name: "Appointment Scheduler",
    icon: Calendar,
    prompt:
      "You are an efficient appointment scheduling assistant. Help customers book, reschedule, or cancel appointments quickly. Be clear about availability, confirm details, and send reminders. Keep conversations brief but friendly.",
  },
  {
    id: "multilingual-support",
    name: "Multilingual Helper",
    icon: Globe,
    prompt:
      "You are a multilingual support assistant. Detect the customer's language and respond in the same language. Be culturally aware and adapt your tone appropriately. Help with inquiries in a friendly, professional manner regardless of the language.",
  },
  {
    id: "lead-qualifier",
    name: "Lead Qualifier",
    icon: Target,
    prompt:
      "You are a smart lead qualification assistant. Engage potential customers, understand their needs, budget, and timeline. Ask qualifying questions naturally without being pushy. Collect contact information and identify hot leads for the sales team.",
  },
];

export const businessTypes = [
  "E-commerce",
  "SaaS",
  "Restaurant",
  "Healthcare",
  "Real Estate",
  "Education",
  "Fitness",
  "Beauty & Wellness",
  "Travel & Hospitality",
  "Professional Services",
  "Retail",
  "Other",
];

export const languages = [
  "English",
  "Swahili",
  "Amharic",
  "Somali",
  "Tigrinya",
  "Oromo",
  "Luganda",
  "Kinyarwanda",
  "Kirundi",
  "Kikuyu",
  "Luo",
  "Spanish",
  "Portuguese",
  "French",
  "German",
  "Italian",
  "Dutch",
  "Arabic",
  "Chinese (Simplified)",
  "Japanese",
  "Korean",
  "Hindi",
];

// Note: autoReply is always enabled by default (core functionality)
export const featuresList = [
  {
    id: "leadCapture",
    name: "Lead Capture",
    description: "Collect contact information from interested customers",
  },
  {
    id: "appointmentBooking",
    name: "Appointment Booking",
    description: "Let customers schedule appointments via chat",
  },
  {
    id: "gmailIntegration",
    name: "Gmail Integration",
    description: "Send emails to customers via your Gmail account",
  },
  {
    id: "humanHandoff",
    name: "Human Handoff",
    description: "Transfer complex queries to human agents",
  },
];

export const llmModels = [
  {
    id: "openai/gpt-4o",
    name: "GPT-4o",
    provider: "OpenAI",
    badge: "Most Powerful",
    badgeColor: "bg-purple-100 text-purple-700",
    description: "OpenAI's most capable model. Best for complex conversations and reasoning.",
    recommended: false,
  },
  {
    id: "anthropic/claude-3-haiku",
    name: "Claude 3 Haiku",
    provider: "Anthropic",
    badge: "Fastest",
    badgeColor: "bg-blue-100 text-blue-700",
    description: "Lightning-fast responses with great accuracy. Ideal for high-volume support.",
    recommended: false,
  },
  {
    id: "anthropic/claude-3.5-sonnet",
    name: "Claude 3.5 Sonnet",
    provider: "Anthropic",
    badge: "Balanced",
    badgeColor: "bg-amber-100 text-amber-700",
    description: "Excellent all-rounder with strong reasoning and helpful personality.",
    recommended: false,
  },
  {
    id: "openai/gpt-4o-mini",
    name: "GPT-4o Mini",
    provider: "OpenAI",
    badge: "Best Value",
    badgeColor: "bg-green-100 text-green-700",
    description: "Great balance of speed and intelligence. Perfect for most businesses.",
    recommended: true,
  },
  {
    id: "google/gemini-2.0-flash-001",
    name: "Gemini 2.0 Flash",
    provider: "Google",
    badge: "Latest",
    badgeColor: "bg-teal-100 text-teal-700",
    description: "Google's latest and fastest model with improved capabilities.",
    recommended: false,
  },
  {
    id: "deepseek/deepseek-chat",
    name: "DeepSeek Chat",
    provider: "DeepSeek",
    badge: "Value",
    badgeColor: "bg-indigo-100 text-indigo-700",
    description: "Cost-effective model with strong reasoning abilities.",
    recommended: false,
  },
  {
    id: "meta-llama/llama-3.1-70b-instruct",
    name: "Llama 3.1 70B",
    provider: "Meta",
    badge: "Open Source",
    badgeColor: "bg-orange-100 text-orange-700",
    description: "Meta's powerful open-source model with excellent performance.",
    recommended: false,
  },
  {
    id: "mistralai/mistral-large-2411",
    name: "Mistral Large",
    provider: "Mistral AI",
    badge: "European",
    badgeColor: "bg-rose-100 text-rose-700",
    description: "European AI with strong multilingual support and privacy focus.",
    recommended: false,
  },
];
